import React, { useRef, memo, ReactNode } from 'react'

import { SpacedGroup } from '@guidde-co/shared.spaced-group'
import { useBoolean } from '@guidde-co/shared.hooks.use-boolean'

import clsx from 'clsx'

import makeStyles from '@material-ui/core/styles/makeStyles'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Checkbox from '@material-ui/core/Checkbox'
import Popper from '@material-ui/core/Popper'
import Paper from '@material-ui/core/Paper'

import Avatar from '@material-ui/core/Avatar'

import PlaylistPlayIcon from '@material-ui/icons/PlaylistPlay'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import IconPlay from '@material-ui/icons/PlayArrow'
import PublicOutlinedIcon from '@material-ui/icons/PublicOutlined'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'

import { PlaybookType } from 'app/types'
import { isQG } from 'modules'

export const formatTime = (seconds: number) => {
    const format = (val: number) => `0${Math.floor(val)}`.slice(-2)

    const hours = seconds / 3600
    const minutes = (seconds % 3600) / 60
    const secs = seconds % 60

    return [hours, minutes, secs].map(format).join(':')
}

const PlaybookIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_12440_107677" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_12440_107677)">
            <path
                d="M4.55 19.5C4.05 19.5 3.625 19.325 3.275 18.975C2.925 18.625 2.75 18.2 2.75 17.7V6.3C2.75 5.8 2.925 5.375 3.275 5.025C3.625 4.675 4.05 4.5 4.55 4.5H15.925C16.4417 4.5 16.875 4.675 17.225 5.025C17.575 5.375 17.75 5.8 17.75 6.3V10.875L21.25 7.375V16.625L17.75 13.125V17.7C17.75 18.2 17.575 18.625 17.225 18.975C16.875 19.325 16.4417 19.5 15.925 19.5H4.55ZM4.55 18H15.925C16.025 18 16.1043 17.971 16.163 17.913C16.221 17.8543 16.25 17.7833 16.25 17.7V6.3C16.25 6.21667 16.221 6.146 16.163 6.088C16.1043 6.02933 16.025 6 15.925 6H4.55C4.46667 6 4.396 6.02933 4.338 6.088C4.27933 6.146 4.25 6.21667 4.25 6.3V17.7C4.25 17.7833 4.27933 17.8543 4.338 17.913C4.396 17.971 4.46667 18 4.55 18ZM10.25 15.525L11.325 13.1L13.75 12L11.325 10.9L10.25 8.475L9.15 10.9L6.725 12L9.15 13.1L10.25 15.525Z"
                fill="white"
            />
        </g>
    </svg>
)

const ConnectedIcon = () => (
    <svg
        data-cy="visibility-connected-icon"
        width="24"
        height="24"
        viewBox="0 0 18 20"
        fill="#828282"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8 19.475C5.83333 18.8917 4.04167 17.621 2.625 15.663C1.20833 13.7044 0.5 11.5167 0.5 9.10005V3.35005L8 0.550049L15.5 3.35005V9.00005C15.2667 8.91672 15.021 8.83738 14.763 8.76205C14.5043 8.68738 14.25 8.62505 14 8.57505V4.40005L8 2.15005L2 4.40005V9.10005C2 9.98338 2.125 10.846 2.375 11.688C2.625 12.5294 2.971 13.3207 3.413 14.062C3.85433 14.804 4.37933 15.4667 4.988 16.05C5.596 16.6334 6.25833 17.1001 6.975 17.4501L7 17.425C7.13333 17.7917 7.30433 18.1417 7.513 18.475C7.721 18.8084 7.95833 19.1167 8.225 19.4C8.19167 19.4167 8.15833 19.4294 8.125 19.438C8.09167 19.446 8.05 19.4584 8 19.475ZM13 15C13.4167 15 13.7707 14.854 14.062 14.562C14.354 14.2707 14.5 13.9167 14.5 13.5C14.5 13.0834 14.354 12.7294 14.062 12.438C13.7707 12.146 13.4167 12 13 12C12.5833 12 12.2293 12.146 11.938 12.438C11.646 12.7294 11.5 13.0834 11.5 13.5C11.5 13.9167 11.646 14.2707 11.938 14.562C12.2293 14.854 12.5833 15 13 15ZM13 18C13.5167 18 13.9917 17.879 14.425 17.637C14.8583 17.3957 15.2083 17.075 15.475 16.675C15.1083 16.4584 14.7167 16.2917 14.3 16.175C13.8833 16.0584 13.45 16 13 16C12.55 16 12.1167 16.0584 11.7 16.175C11.2833 16.2917 10.8917 16.4584 10.525 16.675C10.7917 17.075 11.1417 17.3957 11.575 17.637C12.0083 17.879 12.4833 18 13 18ZM13 19.5C11.75 19.5 10.6873 19.0627 9.812 18.188C8.93733 17.3127 8.5 16.25 8.5 15C8.5 13.75 8.93733 12.6874 9.812 11.812C10.6873 10.9374 11.75 10.5 13 10.5C14.25 10.5 15.3127 10.9374 16.188 11.812C17.0627 12.6874 17.5 13.75 17.5 15C17.5 16.25 17.0627 17.3127 16.188 18.188C15.3127 19.0627 14.25 19.5 13 19.5Z"
            fill="#1C1B1F"
        />
    </svg>
)
export const TeamIcon = () => (
    <svg
        data-cy="visibility-team-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        color="#828282"
    >
        <mask maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="currentColor" />
        </mask>
        <g mask="url(#mask0_4072_10244)">
            <path
                d="M16.95 14.3C16.3167 14.3 15.7834 14.0833 15.35 13.65C14.9167 13.2166 14.7 12.6833 14.7 12.05C14.7 11.4333 14.9167 10.904 15.35 10.462C15.7834 10.0206 16.3167 9.79995 16.95 9.79995C17.5667 9.79995 18.096 10.0206 18.538 10.462C18.9794 10.904 19.2001 11.4333 19.2001 12.05C19.2001 12.6833 18.9794 13.2166 18.538 13.65C18.096 14.0833 17.5667 14.3 16.95 14.3ZM12.2 19.3V18.15C12.2 17.8 12.2877 17.475 12.463 17.175C12.6377 16.875 12.9 16.6666 13.25 16.55C13.8167 16.3 14.4127 16.1126 15.038 15.988C15.6627 15.8626 16.3 15.8 16.95 15.8C17.5834 15.8 18.2084 15.8626 18.8251 15.988C19.4417 16.1126 20.05 16.3 20.65 16.55C20.9834 16.6666 21.2417 16.875 21.425 17.175C21.6084 17.475 21.7001 17.8 21.7001 18.15V19.3H12.2ZM9.80005 11.7C8.85005 11.7 8.02938 11.354 7.33805 10.662C6.64605 9.97062 6.30005 9.14995 6.30005 8.19995C6.30005 7.23328 6.64605 6.40828 7.33805 5.72495C8.02938 5.04162 8.85005 4.69995 9.80005 4.69995C10.7667 4.69995 11.5917 5.04162 12.275 5.72495C12.9584 6.40828 13.3 7.23328 13.3 8.19995C13.3 9.14995 12.9584 9.97062 12.275 10.662C11.5917 11.354 10.7667 11.7 9.80005 11.7ZM2.30005 19.3V17.075C2.30005 16.575 2.43338 16.1166 2.70005 15.7C2.96672 15.2833 3.32505 14.9666 3.77505 14.75C4.70838 14.2833 5.68338 13.925 6.70005 13.675C7.71671 13.425 8.75005 13.3 9.80005 13.3C10.3 13.3 10.796 13.3373 11.288 13.412C11.7794 13.4873 12.275 13.575 12.775 13.675L11.5 14.975C11.2167 14.9083 10.9334 14.8623 10.65 14.837C10.3667 14.8123 10.0834 14.8 9.80005 14.8C8.86672 14.8 7.95005 14.9083 7.05005 15.125C6.15005 15.3416 5.28338 15.6666 4.45005 16.1C4.26672 16.2 4.11238 16.3333 3.98705 16.5C3.86238 16.6666 3.80005 16.8583 3.80005 17.075V17.8H9.80005V19.3H2.30005ZM9.80005 10.2C10.35 10.2 10.821 10.004 11.213 9.61195C11.6044 9.22062 11.8 8.74995 11.8 8.19995C11.8 7.64995 11.6044 7.17895 11.213 6.78695C10.821 6.39562 10.35 6.19995 9.80005 6.19995C9.25005 6.19995 8.77905 6.39562 8.38705 6.78695C7.99572 7.17895 7.80005 7.64995 7.80005 8.19995C7.80005 8.74995 7.99572 9.22062 8.38705 9.61195C8.77905 10.004 9.25005 10.2 9.80005 10.2Z"
                fill="currentColor"
            />
        </g>
    </svg>
)

const visibilityIcons = {
    Private: <LockOutlinedIcon style={{ color: '#828282' }} />,
    Team: <TeamIcon />,
    Connected: <ConnectedIcon />,
    Public: <PublicOutlinedIcon style={{ color: '#828282' }} />
}

const useStyles = makeStyles({
    container: {
        borderRadius: '4px',
        border: '1px solid #E0E0E0',
        overflow: 'hidden',
        position: 'relative',
        height: 220,
        width: '100%'
    },
    block: {
        display: 'flex',
        justifyContent: 'space-between',
        position: 'relative',
        zIndex: 2
    },
    featured: {
        background: '#cd0000',
        fontWeight: 600,
        position: 'absolute',
        top: 0,
        zIndex: 2,
        left: '50%',
        transform: 'translateX(-50%)',
        textTransform: 'uppercase',
        color: '#fff',
        fontSize: '0.5rem',
        padding: '4px',
        borderRadius: '0 0 5px 5px'
    },
    checkboxContainer: {
        zIndex: 3
    },
    checkbox: {
        '&:hover': {
            backgroundColor: 'transparent'
        }
    },
    checkboxIcon: {
        borderRadius: 2,
        border: '2px solid #FFFFFF',
        width: 18,
        height: 18,
        margin: 3
    },
    playbookImg: {
        height: '100%',
        width: '100%',
        objectFit: 'cover',
        zIndex: 0,
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    },
    roundedContainer: {
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(9,12,16, 0.6)',
        position: 'relative',
        zIndex: 4,
        '& svg': {
            fontSize: '14px',
            color: '#fff',
            width: '16px !important',
            height: '16px !important'
        },
        '& img': {
            width: '16px',
            height: '16px',
            objectFit: 'contain'
        }
    },
    menuButton: {
        transition: 'opacity 0.3s linear'
    },
    playBtn: {
        background: '#fff',
        '&:hover': {
            background: 'rgb(255 255 255 / 80%)'
        }
    },
    playInWeb: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 2,
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        '&:hover': {
            '& svg': {
                color: '#cd0000 !important'
            }
        },
        '& svg': {
            color: '#cd0000'
        }
    },
    time: {
        width: 'min-content',
        whiteSpace: 'nowrap'
    },
    bold: {
        fontWeight: 600
    },
    whiteTitle: {
        fontWeight: 600,
        display: '-webkit-box',
        maxWidth: '100%',
        '-webkit-line-clamp': 3,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#fff'
    },
    whiteTitleContainer: {
        textAlign: 'center',
        padding: '0 24px',
        color: '#fff',
        fontSize: '20px',
        maxHeight: '100px',
        position: 'relative',
        zIndex: 2
    },
    title: {
        fontWeight: 600,
        overflowWrap: 'break-word',
        display: '-webkit-box',
        maxWidth: '100%',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        minHeight: '32px',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    noWrap: {
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    username: {
        paddingRight: '8px'
    },
    itemIcon: {
        minWidth: '35px',
        color: 'black'
    },
    divider: {
        margin: '10px 18px',
        background: '#cfd8dc'
    },
    highlighted: {
        zIndex: 2,
        position: 'relative',
        background: '#fff',
        borderRadius: '15px'
    },
    playlistContainer: {
        background: 'rgba(9,12,16, 0.6)',
        borderRadius: 6,
        position: 'absolute',
        color: '#fff',
        top: 10,
        right: 10,
        zIndex: 3
    },
    tags: {
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingRight: '5px'
    },
    '@keyframes pulse': {
        '0%': {
            transform: 'scaleX(1) scaleY(1)'
        },
        '10%': {
            transform: 'translate(-50%, -50%) scaleX(0.85) scaleY(0.85)'
        },
        '20%': {
            transform: 'translate(-50%, -50%) scaleX(1) scaleY(1)'
        },
        '30%': {
            transform: 'translate(-50%, -50%) scaleX(0.85) scaleY(0.85)'
        },
        '40%': {
            transform: 'translate(-50%, -50%) scaleX(1) scaleY(1)'
        },
        '50%': {
            transform: 'translate(-50%, -50%) scaleX(0.85) scaleY(0.85)'
        },
        '60%': {
            transform: 'translate(-50%, -50%) scaleX(1) scaleY(1)'
        },
        '70%': {
            transform: 'translate(-50%, -50%) scaleX(0.85) scaleY(0.85)'
        },
        '80%': {
            transform: 'translate(-50%, -50%) scaleX(1) scaleY(1)'
        },
        '90%': {
            transform: 'translate(-50%, -50%) scaleX(0.85) scaleY(0.85)'
        },
        '100%': {
            transform: 'translate(-50%, -50%) scaleX(0) scaleY(0)'
        }
    },
    pulseAnimation: {
        animation: '$pulse 5s infinite',
        border: '1px solid black'
    },
    duration: {
        background: 'rgba(9,12,16, 0.6)',
        borderRadius: 2,
        fontSize: '12px',
        position: 'absolute',
        color: '#fff',
        bottom: 5,
        right: 5,
        zIndex: 2,
        padding: '2px 4px'
    },
    dropdownRef: { position: 'absolute', top: 30, right: 15, opacity: 0 },
    tooltip: {
        marginTop: '-12px'
    }
})

export type PlaybookCardProps = {
    /**
     * On play click callback
     */
    onPlayClick: (playbook: PlaybookType) => void
    /**
     * Playbook object
     */
    playbook: PlaybookType
    /**
     * On checkbox click callback
     */
    onCheckboxClick?: (playbook: PlaybookType) => void
    /**
     * Menu items
     */
    MenuItems?: ReactNode
    /**
     * Show featured label
     */
    isFeatured?: boolean
    /**
     * Check a checkbox
     */
    checkboxChecked?: boolean
    /**
     * Use for highlighted card
     */
    isHighlighted?: boolean
    /**
     * Use for setting menu z-index
     */
    zIndexMenu?: number
}

export const PlaybookCard = memo(
    ({
        playbook,
        checkboxChecked,
        isFeatured,
        MenuItems,
        isHighlighted,
        zIndexMenu = 5,
        onCheckboxClick,
        onPlayClick
    }: PlaybookCardProps) => {
        const classes = useStyles()

        const anchorRef = useRef(null)

        const hoverState = useBoolean()
        const controls = useBoolean()

        const {
            title,
            originalFileName,
            visibility,
            screenshotUrl,
            playbookList,
            userImage,
            username,
            applications,
            tags,
            duration,
            isPlaylist,
            coverColor
        } = playbook

        const hovered = hoverState.isTrue

        const playbookTitle = title || originalFileName?.replace(/\.mp4$/i, '')
        const playlistLength = playbookList?.length

        const hasExtraTags = tags?.length > 3
        const hasExtraApps = applications.length > 3
        const renderCheckBox = Boolean(onCheckboxClick) && hovered

        return (
            <Box
                className={clsx({
                    [classes.highlighted]: isHighlighted
                })}
                style={{
                    cursor: 'pointer'
                }}
                onClick={() => onPlayClick(playbook)}
                onMouseOver={hoverState.setTrue}
                onMouseLeave={(e: any) => {
                    // prevent closing menu dialogs in `MenuItems` component when user mouse leave page
                    if (!e?.relatedTarget?.nodeName) return

                    hoverState.setFalse()
                    controls.setFalse()
                }}
            >
                <Box className={classes.container} data-cy="playbook-card">
                    {isFeatured && <Box className={classes.featured}>featured</Box>}
                    {!isQG(playbook) && !isPlaylist && !hovered && (
                        <Box className={classes.playlistContainer} p="5px">
                            <PlaybookIcon />
                        </Box>
                    )}
                    {isPlaylist && !hovered && (
                        <SpacedGroup
                            spacing={0.5}
                            className={classes.playlistContainer}
                            px="10px"
                            py="5px"
                        >
                            <PlaylistPlayIcon color="inherit" />
                            <Typography className={classes.bold} color="inherit">
                                {playlistLength}
                            </Typography>
                        </SpacedGroup>
                    )}
                    <Box className={classes.block} alignItems="flex-start">
                        {hovered && MenuItems && !isHighlighted && (
                            <Box
                                data-cy="videocard-context-menu"
                                position="absolute"
                                right={10}
                                top={10}
                                zIndex={5}
                                onClick={e => e.stopPropagation()}
                            >
                                <Box className={classes.roundedContainer} onClick={controls.toggle}>
                                    <div ref={anchorRef} className={classes.dropdownRef} />

                                    <MoreVertIcon fontSize="large" />
                                </Box>

                                <Popper
                                    open={controls.isTrue}
                                    anchorEl={anchorRef?.current}
                                    placement="bottom-start"
                                    disablePortal={false}
                                    style={{ zIndex: zIndexMenu }}
                                >
                                    <Paper
                                        style={{
                                            minWidth: '235px'
                                        }}
                                    >
                                        <MenuItemsMutator
                                            onClose={() => {
                                                hoverState.setFalse()
                                                controls.setFalse()
                                            }}
                                        >
                                            {MenuItems}
                                        </MenuItemsMutator>
                                    </Paper>
                                </Popper>
                            </Box>
                        )}

                        <Box
                            position="absolute"
                            top={5}
                            left={5}
                            className={classes.checkboxContainer}
                            style={{
                                visibility: renderCheckBox || checkboxChecked ? 'visible' : 'hidden'
                            }}
                        >
                            <Checkbox
                                className={classes.checkbox}
                                data-cy="playbook-card-checkbox"
                                checked={checkboxChecked}
                                color="default"
                                checkedIcon={<CheckBoxIcon style={{ color: '#fff' }} />}
                                icon={<span className={classes.checkboxIcon} />}
                                onClick={e => {
                                    e.stopPropagation()
                                    onCheckboxClick?.(playbook)
                                }}
                            />
                        </Box>
                    </Box>
                    <Box
                        height={125}
                        position="relative"
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        zIndex={1}
                        style={
                            hovered
                                ? {}
                                : {
                                      background: isQG(playbook) ? coverColor : ''
                                  }
                        }
                    >
                        {(hovered || isHighlighted) && (
                            <Box width={50} height={50} bgcolor="#cb4000">
                                <IconButton
                                    className={clsx(classes.playBtn, classes.playInWeb, {
                                        [classes.pulseAnimation]: isHighlighted
                                    })}
                                    data-cy="play-button"
                                >
                                    <IconPlay fontSize="medium" />
                                </IconButton>
                            </Box>
                        )}

                        {hovered && (
                            <Box
                                bgcolor="rgba(9, 12, 16, 0.4)"
                                position="absolute"
                                left={0}
                                right={0}
                                top={0}
                                bottom={0}
                                zIndex={1}
                            />
                        )}
                        {screenshotUrl || coverColor ? (
                            <>
                                {coverColor ? (
                                    <>
                                        <Box className={classes.whiteTitleContainer}>
                                            <Box className={classes.whiteTitle}>
                                                {playbookTitle}
                                            </Box>
                                        </Box>
                                        <Box
                                            bgcolor={coverColor}
                                            position="absolute"
                                            left={0}
                                            right={0}
                                            top={0}
                                            bottom={0}
                                        />
                                    </>
                                ) : (
                                    <img className={classes.playbookImg} src={screenshotUrl} />
                                )}
                            </>
                        ) : (
                            <Box
                                height="100%"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <CircularProgress />
                            </Box>
                        )}

                        {!isPlaylist && Boolean(duration) && !hovered && (
                            <Box className={classes.duration}>{formatTime(duration)}</Box>
                        )}
                        {hovered && (
                            <Box
                                position="absolute"
                                bottom={5}
                                left={5}
                                right={5}
                                color="#fff"
                                zIndex={2}
                            >
                                <Box display="flex" alignItems="center">
                                    <Box
                                        maxWidth="90%"
                                        overflow="hidden"
                                        whiteSpace="nowrap"
                                        textOverflow="ellipsis"
                                    >
                                        <Typography
                                            variant="caption"
                                            color="inherit"
                                            style={{ fontWeight: 700 }}
                                            className={classes.tags}
                                        >
                                            {applications
                                                ?.slice(0, 3)
                                                .filter(Boolean)
                                                .map(it => it.applicationName + ' ')}
                                        </Typography>
                                    </Box>
                                    <Typography
                                        variant="caption"
                                        color="inherit"
                                        style={{ fontWeight: 700 }}
                                    >
                                        {hasExtraApps && `+${applications.length - 3}`}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <Box
                                        maxWidth="90%"
                                        overflow="hidden"
                                        whiteSpace="nowrap"
                                        textOverflow="ellipsis"
                                    >
                                        <Typography
                                            variant="caption"
                                            color="inherit"
                                            className={classes.tags}
                                        >
                                            {tags
                                                ?.slice(0, 3)
                                                .filter(Boolean)
                                                .map(tag => '#' + tag + ' ')}
                                        </Typography>
                                    </Box>
                                    <Typography variant="caption" color="inherit">
                                        {hasExtraTags && `+${tags.length - 3}`}
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                    </Box>

                    <Box px={1.1} py={1}>
                        <Box height={40}>
                            <Typography variant="caption" className={classes.title}>
                                {playbookTitle}
                            </Typography>
                        </Box>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            mt={1}
                        >
                            <SpacedGroup spacing={1}>
                                <Avatar
                                    src={userImage}
                                    style={{
                                        height: 24,
                                        width: 24
                                    }}
                                />
                                <Typography
                                    variant="caption"
                                    className={clsx(classes.noWrap, classes.username)}
                                >
                                    {username}
                                </Typography>
                            </SpacedGroup>
                            {visibility && visibilityIcons[visibility]}
                        </Box>
                    </Box>
                </Box>
            </Box>
        )
    }
)

type MenuItemsMutatorProps = {
    children: ReactNode
    onClose: () => void
}
const MenuItemsMutator = ({ children, onClose }: MenuItemsMutatorProps) => {
    //  pass `onClose` function into the child elements.

    const childrenWithProps = React.Children.map(children, child => {
        // Checking isValidElement is the safe way and avoids a
        // typescript error too.
        if (React.isValidElement(child)) {
            // @ts-ignore put callback inside children (not a component as usual)
            return React.cloneElement(child, { onClose })
        }
        return child
    })

    return <div>{childrenWithProps}</div>
}
